import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class AlertService {
    private subject = new Subject<Alert>();
    private keepAfterRouteChange = false;

    constructor(private router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert messages
                    this.clear();
                }
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false, seconds: number = 0) {
        this.alert(AlertType.Success, message, keepAfterRouteChange, seconds);
    }

    error(message: string, keepAfterRouteChange = false, seconds: number = 0) {
        this.alert(AlertType.Error, message, keepAfterRouteChange, seconds);
    }

    info(message: string, keepAfterRouteChange = false, seconds: number = 0) {
        this.alert(AlertType.Info, message, keepAfterRouteChange, seconds);
    }

    warn(message: string, keepAfterRouteChange = false, seconds: number = 0) {
        this.alert(AlertType.Warning, message, keepAfterRouteChange, seconds);
    }

    alert(type: AlertType, message: string, keepAfterRouteChange = false, seconds: number = 0) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<Alert>{ type: type, message: message, seconds: seconds });
    }

    clear() {
        // clear alerts
        this.subject.next();
    }
}

export class Alert {
  type: AlertType;
  message: string;
  seconds: number;
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}


// WEBPACK FOOTER //
// ./src/app/alert.service.ts